import React, { useState } from 'react';
import ProjectOwnerRow from './ProjectOwnerRow';
import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const tableHeadings = ['name', 'half_year_required', 'bda_check_if_yes', 'fulltime', 'digital_record', 'project_working_time', 'actual_working_time', '', '', ''];
const ProjectOwner = _ref => {
  let {
    projectOwners,
    setSelectedProject,
    setProjectReports,
    projectReports,
    selectedProjectId,
    selectedProject
  } = _ref;
  const {
    t
  } = useTranslation();
  const [emptyProjectOwners, setEmptyProjectOwners] = useState([]);
  const tableHeadingRow = tableHeadings.map((heading, i) => {
    return /*#__PURE__*/React.createElement("th", {
      key: 'th' + i
    }, t(heading));
  });
  const removeEmptyRow = rowIdToRemove => {
    const newList = emptyProjectOwners.filter(emptyNameList => emptyNameList.emptyRowId !== rowIdToRemove);
    setEmptyProjectOwners([...newList]);
  };
  const addContact = () => {
    const newEmptyRowData = {
      emptyRowId: 0,
      name: '',
      year: 'after_30_06_2020',
      bda: false,
      fulltime: false,
      digital_record: false,
      project_working_time: 0,
      actual_working_time: 0,
      project_elster_detail_id: selectedProject.project_elster_detail.id
    };
    if (!!emptyProjectOwners.length) {
      const largestId = Math.max(...emptyProjectOwners.map(emptyNameList => emptyNameList.emptyRowId));
      setEmptyProjectOwners([...emptyProjectOwners, {
        ...newEmptyRowData,
        emptyRowId: largestId + 1
      }]);
    } else if (!emptyProjectOwners.length) {
      setEmptyProjectOwners([newEmptyRowData]);
    }
  };
  const tableRows = projectOwners.map(projectOwner => {
    return /*#__PURE__*/React.createElement(ProjectOwnerRow, {
      setSelectedProject: setSelectedProject,
      rowData: projectOwner,
      key: projectOwner.id,
      setProjectReports: setProjectReports,
      projectReports: projectReports,
      selectedProject: selectedProject
    });
  });
  const emptyRows = emptyProjectOwners.map(emptyProjectOwner => {
    return /*#__PURE__*/React.createElement(ProjectOwnerRow, {
      rowData: emptyProjectOwner,
      setSelectedProject: setSelectedProject,
      setProjectReports: setProjectReports,
      projectReports: projectReports,
      selectedProject: selectedProject,
      key: 'createRowProjectOwner' + emptyProjectOwner.emptyRowId,
      emptyRowId: emptyProjectOwner.emptyRowId,
      removeEmptyRow: removeEmptyRow
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    icon: "add",
    loading: false,
    onClick: () => {
      addContact();
    }
  }, t('add_contact')), /*#__PURE__*/React.createElement(Table, {
    responsive: "md"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeadingRow)), /*#__PURE__*/React.createElement("tbody", null, tableRows, emptyRows)));
};
export default ProjectOwner;